import { OrderTicket } from "../API";
import { APIClass, graphqlOperation } from "aws-amplify";
import { orderTicketDetailApiToModel } from "./OrderTicket";
import { getOrderTicket } from "../graphql/queries";
import { GraphQLResult } from "@aws-amplify/api-graphql/src/types";
import { OrderTicketDetailEntity } from "@goodfill/domain-entities";
import { OrderTicketId } from "@goodfill/domain-properties";

export interface GetOrderTicketData {
  getOrderTicket: OrderTicket;
}

export async function doGetOrderTicket(
  graphqlApi: Pick<APIClass, "graphql">,
  orderTicketId: OrderTicketId
): Promise<OrderTicketDetailEntity> {
  const operation = graphqlOperation(getOrderTicket, { id: orderTicketId });
  const result = (await graphqlApi.graphql(
    operation
  )) as GraphQLResult<GetOrderTicketData>;

  if (result.data === undefined) {
    throw new Error("doGetOrderTicket: data must not be undefined");
  }

  return orderTicketDetailApiToModel(result.data.getOrderTicket);
}
